import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import combineStyles from '../../utils/combineStyles';
import BasicInfoStyles from './__styles__/BasicInfo.styles';
import TypographyStyles from '../../styles/typography';

export class BasicInfo extends Component {
  static propTypes = {
    type: PropTypes.string.isRequired,
    details: PropTypes.array.isRequired
  };

  render() {
    const { classes, type, details = [] } = this.props;

    return (
      <div className={classes.root}>
        <h3 className={classes.subtitle2}>{type}</h3>
        {details.map((detail, index) => (
          <p key={index} className={classes.body2Light}>
            {detail}
          </p>
        ))}
      </div>
    );
  }
}

export default withStyles(combineStyles(BasicInfoStyles, TypographyStyles))(
  BasicInfo
);
